import React from 'react';

const LoadingSpinner = () => (
  <div className="flex justify-center items-center min-h-64 bg-cream-100 dark:bg-gray-800/30 rounded-2xl">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500" />
  </div>
);

export default LoadingSpinner;
